import Images from "../../assets";
import Footer from "../FormFooter/FormFooter";
import moment from "moment/moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default function ForwardcontractConfirmation() {

    const handleDownloadPDF = async () => {
        alert("Download Start");
        // const pdf = new jsPDF("p", "mm", "a4");
        const pdf = new jsPDF("p", "mm", [210, 375]);
        const options = {
            scale: 2,
            useCORS: true,
        };

        const captureDiv = async (id) => {
            const element = document.getElementById(id);
            if (element) {
                const canvas = await html2canvas(element, options);
                return canvas.toDataURL("image/png");
            }
            return null;
        };

        const imgData1 = await captureDiv("fwcntcnf-sheet1-content");

        const imgWidth = 210; // A4 width in mm
        const addImageToPdf = (imgData, addPage = false) => {
            return new Promise((resolve) => {
                const img = new Image();
                img.src = imgData;
                img.onload = () => {
                    const imgHeight = (img.height * imgWidth) / img.width;
                    if (addPage) pdf.addPage();
                    pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
                    resolve();
                };
            });
        };

        if (imgData1) await addImageToPdf(imgData1);

        pdf.save("Forward Contract Confirmation.pdf");
    };
    return (
        <>
            <div className="status-waiver-block" id="fwcntcnf-sheet1-content">
                <div style={{ minHeight: "1230px" }}>
                    <div className="status-logo py-1 ">
                        <img
                            src={Images.logo}
                            alt="logo"
                            style={{ height: "90%", width: "30%" }}
                        />
                        <p className="file-name-title">
                            {/* {sessionData && sessionData?.fileName} */}
                            Forward Contract Confirmation
                        </p>
                    </div>
                    <div className="d-flex flex-column pt-2 px-5">
                        <div className="pt-2">
                            <p className="status-waiver-content">To</p>
                        </div>
                        <div className="d-flex flex-column">
                            <span className="status-waiver-content">SOUTH INDIAN BANK</span>
                            <span className="status-waiver-content">G.T. CHENNAI</span>
                            <span className="status-waiver-content">
                                P.B. NO: 1549, 64, ARMENIAN STREET <br />
                                CATHOLIC CENTRE, MADRASG.T
                            </span>
                            <span className="status-waiver-content">CHENNAI</span>
                            <span className="status-waiver-content">TAMIL NADU - 600001</span>
                        </div>
                        <br />
                        <div className="d-flex flex-column">
                            <div className="d-flex justify-content-between">
                                <span className="status-waiver-content">From</span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <span className="status-waiver-content">BESTTMBERS</span>
                                <span className="status-waiver-content">Date:{moment().format("DD.MM.YYYY")}</span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <span className="status-waiver-content">NEW NO:515,0LD NO:274,SYDENHAMS RD,</span>
                                <span className="status-waiver-content">Contract Matures On: 05-10-2026</span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <span className="status-waiver-content">NEHRU TIMBER MARKET CHENNAI</span>
                                <span className="status-waiver-content">ISDA Date: </span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <span className="status-waiver-content">INDIA-600112</span>
                            </div>
                        </div>
                        <p className="status-waiver-content mt-2">Treasury Ref Number: 1076164</p>
                        <p className="status-waiver-content mt-2">Forward Contract No. 0042F01026</p>
                        <p className="status-waiver-content mt-2">We confirm having this day booked with you the following Exchange.</p>
                        <br />
                        <table>
                            <thead>
                                <tr>
                                    <th className="forward_head_label"><b>Currency & Amount</b></th>
                                    <th className="forward_head_label"><b>Exchange rate</b></th>
                                    <th className="forward_head_label"><b>Booked Date</b></th>
                                    <th className="forward_head_label"><b>Delivery</b></th>
                                    <th className="forward_head_label"><b>Resultant Currency</b></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="forward_body_label">USD 17,390.65</td>
                                    <td className="forward_body_label">94.47033</td>
                                    <td className="forward_body_label">17-04-2026</td>
                                    <td className="forward_body_label">05-10-2026 to 05-10-2026</td>
                                    <td className="forward_body_label">INR 16,42,900.44</td>
                                </tr>
                            </tbody>
                        </table>
                        <br />
                        <p className="status-waiver-content">We hereby agree and confirm the above forward rate booking details.</p>
                        <p className="status-waiver-content">Subject to rules and regulations of the Foreign Exchange Dealer's Association, Mumbai.</p>
                        <br />
                        <p className="status-waiver-content">I/We confirm the above contract is as per my request to the Bank. </p>
                        <p className="status-waiver-content"><b>General Terms and Conditions</b></p>
                        <br />
                        <ol>
                            <li className="status-waiver-content">We confirm that the forward contract booked is covered under Master Facility Agreement for
                                Forward Contract signed by us on</li>
                            <li className="status-waiver-content">Forward contract is firm and we undertake to take delivery during the contracted period.</li>
                            <li className="status-waiver-content"> In the event of extension/rollover/cancellation, we undertake to submit to the Bank our
                                application for cancellation of contract before expiry date of contracted period.</li>
                            <li className="status-waiver-content">In the absence of our instruction, Bank is authorized to cancel the contract after due date, in
                                keeping with extant RBI and FEDAI guidelines. We agree that gains if any on cancellation
                                after due date will not be passed. We also authorize the bankto debit our account for any losses/cost associated with such cancellation after due date. </li>
                        </ol>
                        <div className="d-flex flex-column">
                            <img
                                src={Images?.signIcon}
                                alt="on-image"
                                style={{ width: "100px", height: "40px" }}
                            />
                            (Authorised Signatory)
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
            <div
                style={{
                    textAlign: "center",
                    paddingTop: "1rem",
                    paddingBottom: "1rem",
                    paddingLeft: "3rem",
                    marginLeft: "3rem",
                }}
            >
                <button className="btn_download_file" onClick={handleDownloadPDF}>
                    DOWNLOAD Forward-Contract-Confirmation
                </button>
            </div>
        </>)
}